import { z } from 'zod';
export var ApplicationPaymentInformation = z.object({
  requiresPayment: z["boolean"]()
});
export var ApplicationPaymentInformationResponse = z.object({
  attributes: ApplicationPaymentInformation,
  type: z.literal('application_payment_information')
});